import { Route, Routes, useNavigate } from "react-router-dom";
import { PaymentList } from "./Components/paymentList";
import { ExpenseList } from "./Components/expenseManagementSystem/expenseList";
import VendorsList from "./Components/Vendor-management/VendorsList";
import PricingHomePage from "./Components/Pricing/PricingHomePage";
import PricingSectionPage from "./Components/Pricing/PricingSectionPage";
import InvoiceManagement from "./Components/invoice-generation-engine/InvoiceManagement";
import Collection from "./Components/invoice-generation-engine/collection";
import { useState } from "react";
import { Vendor } from "shared-types";
import { VendorForm } from "./Components/Vendor-management/VendorForm";
import { CreateExpensePage } from "./Components/expenseManagementSystem/CreateExpensePage";
import { ExpensesPage } from "./Components/expenseManagementSystem/ExpensesPage";
import { VendorSelectorSummary } from "./Components/Vendor-management/VendorSummary";

export const BillingRouting = () => {
    useNavigate();
    const [vendors, setVendors] = useState<Vendor[]>([]);

    return (
        <Routes>
            <Route path="" element={ <InvoiceManagement/> }/>
            <Route path="invoice" element={ < InvoiceManagement/> }/>
            <Route path="collection" element={ < Collection/> }/>
            <Route path="payments" element={ <PaymentList/> }/>
            <Route path="expenses" element={ <ExpenseList/> }/>

            <Route path="vendor" element={ <VendorsList vendors={ vendors } setVendors={ setVendors }/> }/>
            <Route path="vendor/new" element={ <VendorForm vendors={ vendors } setVendors={ setVendors }/> }/>
            <Route path="vendor/:id" element={<VendorSelectorSummary vendors={vendors} />} />
            <Route path="vendor/:id/edit" element={ <VendorForm vendors={ vendors } setVendors={ setVendors }/> }/>

            <Route path="pricing" element={ <PricingHomePage/> }/>
            <Route path="pricing/workspace" element={ <PricingSectionPage type="workspace"/> }/>
            <Route path="pricing/meeting-room" element={ <PricingSectionPage type="meeting-room"/> }/>
            <Route path="pricing/lounge" element={ <PricingSectionPage type="lounge"/> }/>


            <Route path="expense-form" element={ <CreateExpensePage/> }/>
            <Route path="expense-form/:id" element={<ExpensesPage />} />

            {/* <Route path="expenses" element={<ExpenseList />} /> */ }
            <Route path="expenses" element={<ExpensesPage/>} />
            {/* <Route path="expense-form" element={<CreateExpenseForm />} /> */ }
            {/* <Route path="expenses/expense-form" element={<CreateExpenseForm />} /> */ }
            {/* <Route path="expenses/expense-form/:id" element={<CreateExpenseForm />} /> */ }


            {/* <Route path="expense-form" element={<CreateExpenseForm />} /> */ }
        </Routes>
    );
};